import moment from 'moment';
import _ from 'lodash';
import { PROHIBITED_SLOT_STATUSES, SLOT_STATUSES } from '../../utils/constants/appointmentSessionConstants';

export const AppointmentSlotStatus = {
  REGISTRATION: "REGISTRATION",
  ADMITTED: "ADMITTED",
  TREATMENT: "TREATMENT",
  DISCHARGED: "DISCHARGED",
  DEPARTED: "DEPARTED",
  WAITING: "WAITING",
  PENDING: "PENDING",
  TRANSFERRED: "TRANSFERRED",
  CANCELLED: "CANCELLED",
  DELETED: "DELETED",
};

export const BookedSlotHeaderStatusColors = {
    [SLOT_STATUSES.NOT_REGISTERED.value]: { backgroundColor: '#FFFFFF', color: '#000' },
    [SLOT_STATUSES.ARRIVED.value]: { backgroundColor: '#2180F7', color: '#FFF' },
    [SLOT_STATUSES.CALLED.value]: { backgroundColor: '#F7A202', color: '#FFF' },
    [SLOT_STATUSES.BEEING_SEEN.value]: { backgroundColor: '#4EAC6F', color: '#FFF' },
    [SLOT_STATUSES.DEPARTED.value]: { backgroundColor: 'darkgray', color: '#FFF' },
    [SLOT_STATUSES.DNA.value]: { backgroundColor: '#E25B61', color: '#FFF' },
    [SLOT_STATUSES.WNB.value]: { backgroundColor: '#E25B61', color: '#FFF' },
    [PROHIBITED_SLOT_STATUSES.DELETED.value]: { backgroundColor: 'darkgray', color: '#000' },
    [PROHIBITED_SLOT_STATUSES.LOCKED.value]: { backgroundColor: '#ACAFB3', color: '#000' },
};

export function generateAvailableHours(parsedDate, session, slots) {
  const sessSlots =  session.daySlots?.[parsedDate.format('YYYY_MM_DD')];
  let allSlots = _.unionWith(slots,sessSlots , (arrVal, othVal) => {
    return arrVal.startDate.isSame(othVal.startDate) && arrVal.assignedSession === othVal.assignedSession;
  });
  let availableSlots = _.filter(allSlots, s => {return !s.patientId && s.status !== PROHIBITED_SLOT_STATUSES.LOCKED.value}).sort((a,b) => new Date(a?.startDate) - new Date(b?.startDate));
  return _.map(availableSlots, s => { return { hour: s.startDate.toISOString(), outsideSessionSlotId: s?.status === PROHIBITED_SLOT_STATUSES.AVAILABLE.value ? s?.__id : null }; });
}

// export function generateAssignableSlots(date, session, slots) {
//   const availableHours = generateAvailableHours(date, session, slots);
//
//   return availableHours.map((hour) => {
//     return {
//       startDate: hour,
//       endDate: moment(hour)
//         .add(session.slotDurationInMinutes, "minute")
//         .toISOString(),
//       status: AppointmentSlotStatus.PENDING,
//     };
//   });
// }

export function orderSessions(date, sessions) {
    const formattedDate = moment(date).format('YYYY_MM_DD');

    if (_.isEmpty(sessions)) return [];
    else return _.orderBy(
        sessions,
        (sess) => {
            const firstEl = _.first(sess?.daySlots?.[formattedDate]);

            if (firstEl?.startDate) {
                const firstStart = firstEl?.startDate;
                return moment(firstStart).format(
                    'HH:mm'
                );
            }
        },
        ['asc']
    );
}

// const findSlotBetweenDates = (slots, start, end) => {
//     const startDate = new Date(start);
//     const endDate = new Date(end);
//
//     for (let i = slots.length - 1; i >= 0; i--) {
//         const slot = slots[i];
//         const slotStart = new Date(slot.startDate);
//         const slotEnd = new Date(slot.endDate);
//
//         if (
//             (startDate >= slotStart && startDate <= slotEnd) ||
//             (endDate > slotStart && endDate < slotEnd)
//         ) {
//             return slot;
//         }
//     }
//
//     return null;
// };
//
// export function generateOutsideSessionSlots(session, dateSlots, date) {
//     if (!session.startDate || !session.endDate) return [];
//
//     const { startDate, endDate, slotDurationInMinutes } = session;
//
//     // Pre-calculate all time values - ensure we're working in LOCAL time
//     // Force conversion to local time to handle both UTC and local moment objects
//     const localDate = moment(date).local();
//     const dayStart = localDate.clone().startOf('day');
//     const dayEnd = localDate.clone().endOf('day');
//
//     // Parse session times in LOCAL timezone (not UTC)
//     const sessionStartParsed = moment(startDate);
//     const sessionEndParsed = moment(endDate);
//
//     const sessionStart = dayStart.clone().set({
//         hour: sessionStartParsed.hours(),
//         // minute: roundToSlotBoundary(sessionStartParsed.minutes(), slotDurationInMinutes),
//         minute: sessionStartParsed.minutes(),
//         second: 0,
//         millisecond: 0,
//     });
//     const sessionEnd = dayStart.clone().set({
//         hour: sessionEndParsed.hours(),
//         minute: sessionEndParsed.minutes(),
//         second: 0,
//         millisecond: 0,
//     });
//
//     // Pre-calculate time boundaries as milliseconds for faster comparison
//     const sessionStartMs = sessionStart.valueOf();
//     const sessionEndMs = sessionEnd.valueOf();
//
//     // Build slot map with pre-filtered slots (outside session only)
//     // Store both the slot and its pre-calculated timestamps
//     const slotMap = new Map();
//     for (let i = 0; i < dateSlots.length; i++) {
//         const sl = dateSlots[i];
//         const slStartMs = moment(sl.startDate).valueOf();
//         const slEndMs = moment(sl.endDate).valueOf();
//
//         // Check if slot is outside session boundaries
//         if ((slStartMs < sessionStartMs && slEndMs <= sessionStartMs) || (slStartMs >= sessionEndMs && slEndMs >= sessionEndMs)) {
//             // Store slot with pre-calculated timestamps to avoid repeated moment() calls
//             slotMap.set(slStartMs, { slot: sl, startMs: slStartMs, endMs: slEndMs });
//         }
//     }
//
//     const slots = [];
//
//     // Generate slots before session using moment objects (not milliseconds) for timezone consistency
//     const beforeSlots = [];
//     let timeMoment = sessionStart.clone().subtract(slotDurationInMinutes, 'minutes');
//
//     while (timeMoment.isSameOrAfter(dayStart, 'minute')) {
//         const timeMomentMs = timeMoment.valueOf();
//         const slotData = slotMap.get(timeMomentMs);
//
//         if (slotData) {
//             const { slot, startMs, endMs } = slotData;
//             if (!slot?.patientId) beforeSlots.push(slot);
//             // If we found an existing slot, jump to its start for next iteration
//             timeMoment = moment(startMs).subtract(slotDurationInMinutes, 'minutes');
//         } else {
//             // Create new slot object only when needed
//             beforeSlots.push({
//                 startDate: timeMoment.toISOString(),
//                 assignedSession: session?.__id,
//                 outsideSession: true,
//             });
//             timeMoment.subtract(slotDurationInMinutes, 'minutes');
//         }
//     }
//
//     // Reverse and add before slots (avoid spread for better performance)
//     for (let i = beforeSlots.length - 1; i >= 0; i--) {
//         slots.push(beforeSlots[i]);
//     }
//
//     // Generate slots after session using moment objects (not milliseconds) for timezone consistency
//     timeMoment = moment(sessionEnd.toISOString());
//
//     let iterationCount = 0;
//     while (timeMoment.isBefore(dayEnd, 'minute')) {
//         const timeMomentMs = timeMoment.valueOf();
//         const slotData = slotMap.get(timeMomentMs);
//
//         if (slotData) {
//             const { slot, startMs, endMs } = slotData;
//             if (!slot?.patientId) {
//                 slots.push(slot);
//             }
//             // If we found an existing slot, jump to its end for next iteration
//             timeMoment = moment(endMs);
//         } else {
//             const newSlot = {
//                 startDate: timeMoment.toISOString(),
//                 assignedSession: session?.__id,
//                 outsideSession: true,
//             };
//             slots.push(newSlot);
//             timeMoment.add(slotDurationInMinutes, 'minutes');
//         }
//
//         iterationCount++;
//         if (iterationCount > 100) {
//             console.error('⚠️ Too many iterations, breaking');
//             break;
//         }
//     }
//
//     return slots;
// }
